<div id="mobile-banking-details-form">

  <div class="mt-3">
    <kl-update-fpo-banking-details (closeDialog)="ok()"></kl-update-fpo-banking-details>
  </div>

</div>
